import { getAbsencesApiCall } from '@/entities/Absence/AbsenceService'
import { isFetchResultSuccessful } from '@/entities/FetchResult'
import { TypedDispatch } from '@/redux/store'

import { setAbsences, setError, setIsLoading } from './absencesReducer'

export const getAbsences = (year: number) => async (dispatch: TypedDispatch): Promise<void> => {
    dispatch(setIsLoading(true))

    try {
        const response = await getAbsencesApiCall(year)

        if (! isFetchResultSuccessful(response)) {
            dispatch(setIsLoading(false))

            return
        }

        dispatch(setAbsences(response.data))
    } catch (error) {
        console.error('[fetchAbsences]', error)

        dispatch(setError('Error fetching data'))
    } finally {
        dispatch(setIsLoading(false))
    }
}
